import React, { memo, useState } from "react";
import OrderBookListItem from "./OrderBookListItem";
import OrderViewModal from "./OrderViewModal";
import { OrderStatus } from "./Constants";
import { IonNote } from "@ionic/react";
import { CMEDPermissions } from "../MarketData/MarketDataContent";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

type OrderBookListComponentProps = {
  data: {
    id: string;
    b: any; //side
    p: any; //contract name
    d: any; //contract date
    p2: any; //price
    fq: any; //filled
    q: any; //number of total fills
    marketData: any; //all the bid,offer
    s: any; //status
  }[];
  searchVal: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
};

const OrderBookListComponent: React.FC<OrderBookListComponentProps> = ({
  data,
  searchVal,
  userCMEDEntitlements,
}) => {
  const [openOrderViewModal, setOpenOrderViewModal] = useState<boolean>(false);
  const [orderId, setOrderId] = useState<string>("");
  const [orderLoading, setOrderLoading] = useState(false);
  const [marketDataLoading, setMarketDataLoading] = useState(false);
  const [fillsDataLoading, setFillsDataLoading] = useState(false);

  const closeOrderViewModal = () => {
    setOpenOrderViewModal(false);
  };

  const statusGetter = (orderStatus: number | undefined) => {
    switch (orderStatus) {
      case 0:
      case 3:
      case 8:
        return OrderStatus.HELD;
        break;
      case 1:
      case 2:
        return OrderStatus.WORKING;
        break;
      case 7:
        return OrderStatus.PENDING;
        break;
      case 4:
      case 5:
        return OrderStatus.FILLED;
        break;
      case 6:
        return OrderStatus.CANCELLED;
        break;
      default:
        return OrderStatus.HELD;
        break;
    }
  };

  const doFilterItOut = (data: any, searchString: any) => {
    return data?.filter(
      (item: any) =>
        item?.p.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.b.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.d.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        statusGetter(item?.s)
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()) ||
        item?.t.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.ti?.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.a?.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.p2?.f.toLowerCase().includes(searchString.toLocaleLowerCase()) ||
        item?.marketData?.bb?.f
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()) ||
        item?.marketData?.b?.f
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()) ||
        item?.marketData?.bo?.f
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()) ||
        item?.marketData?.boq?.f
          .toLowerCase()
          .includes(searchString.toLocaleLowerCase()),
    );
  };
  const filteredData = doFilterItOut(data, searchVal);
  return (
    <React.Fragment>
      <>
        {filteredData.length > 0 ? (
          filteredData.map((elem: any, index: any) => (
            <OrderBookListItem
              key={index}
              side={elem?.b}
              contract={elem?.p + " " + elem?.d}
              orderStatus={elem?.s}
              orderId={elem?.id}
              price={elem?.p2?.f}
              fills={elem?.fq?.f + "/" + elem?.q?.f}
              bid={elem?.marketData?.bb?.f}
              bidQty={elem?.marketData?.b?.f}
              offer={elem?.marketData?.bo?.f}
              offerQty={elem?.marketData?.boq?.f}
              index={index}
              setOpenOrderViewModal={setOpenOrderViewModal}
              setOrderId={setOrderId}
              setOrderLoading={setOrderLoading}
              setMarketDataLoading={setMarketDataLoading}
              setFillsDataLoading={setFillsDataLoading}
            />
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              flexDirection: "column",
            }}
          >
            <IonNote
              color="medium"
              style={{ fontSize: "var(--one-font-size-10)" }}
            >
              No Orders Found
            </IonNote>
          </div>
        )}
      </>
      <OrderViewModal
        orderId={orderId}
        setOrderId={setOrderId}
        openOrderViewModal={openOrderViewModal}
        closeOrderViewModal={closeOrderViewModal}
        setOpenOrderViewModal={setOpenOrderViewModal}
        orderLoading={orderLoading}
        setOrderLoading={setOrderLoading}
        marketDataLoading={marketDataLoading}
        setMarketDataLoading={setMarketDataLoading}
        fillsDataLoading={fillsDataLoading}
        setFillsDataLoading={setFillsDataLoading}
        userCMEDEntitlements={userCMEDEntitlements}
      />
    </React.Fragment>
  );
};

export default memo(OrderBookListComponent);
